import React from "react";
import { Box, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";

const CommonTitle = ({ title }) => {
  return (
    <Box
      sx={(theme) => ({
        width: "100%",
        display: "flex",
        marginY: "1rem",
        alignItems: "center",
        justifyContent: "space-between",
        padding: `${theme.spacing(2)} ${theme.spacing()}px`,
        gap: theme.spacing(2),
      })}
    >
      <Box sx={{ flex: 1, height: "0.1rem", backgroundColor: grey[300] }} />
      <Typography align="center" color={grey[700]} variant="subtitle1">
        {title}
      </Typography>
      <Box sx={{ flex: 1, height: "0.1rem", backgroundColor: grey[300] }} />
    </Box>
  );
};

export default CommonTitle;
